import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.gray.dark,
  },
  titleContainer: {
    padding: theme.spacing(1.625, 2.5, 1.625, 2.5),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  content: {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '&.MuiDialogContent-dividers': {
      borderColor: theme.palette.black.light,
    },
  },
  closeIcon: {
    width: theme.spacing(1.625),
  },
  mapContainer: {
    height: theme.spacing(90),
    width: '100%',
    '& .leaflet-container': {
      height: '100%',
      width: '100%',
    },
  },
}));
